import { render, staticRenderFns } from "./WholePicture.vue?vue&type=template&id=bc41b53a&"
import script from "./WholePicture.vue?vue&type=script&lang=js&"
export * from "./WholePicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports